export default {
  path: '/nozzle_types',
  name: 'nozzle_types',
  component: () => import('../components/nozzletype/Layout'),
  redirect: { name: 'NozzleTypeList' },
  meta: {
    breadcrumb: 'profile.nozzle.types',
  },
  children: [
    {
      name: 'NozzleTypeList',
      path: '',
      component: () => import('../views/nozzletype/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'NozzleTypeCreate',
      path: 'new',
      component: () => import('../views/nozzletype/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'NozzleTypeUpdate',
      path: ':id/edit',
      component: () => import('../views/nozzletype/Update'),
      meta: {
        breadcrumb: 'profile.nozzle.type',
      },
    },
    {
      name: 'NozzleTypeShow',
      path: ':id',
      component: () => import('../views/nozzletype/Show'),
      meta: {
        breadcrumb: 'profile.nozzle.type',
      },
    }
  ]
};
